export default {
  paymentMethods: 'payment_methods',
  rewardPercent: 'reward_percent',
  minimumPurchaseAmount: 'minimum_purchase_amount',
  isOuter: 'is_outer',
};
